
import EditPolyline from "../plot/EditPolyline.js"
import EditBase from "../plot/EditBase"
import { getSpace, getDistanceText } from "./utils/index"
class EditDistanceSpace extends EditPolyline {

    constructor(options) {
        super(options);
        this.initCenter=false;
        this.initRotate=false;
    }

    initKeyPoint() {
        var entitiesLabel = this.plot.attrPlot['entitiesLabel'];
        for (let i = 0; i < entitiesLabel.length; i++) {
            var pos = entitiesLabel[i];
            pos.attrPlot = {
                e_index: i,
                [EditBase.ext_id]: this.editGuid,
                [EditBase.ext_keyFlag]: true
            };
        }
        this.plot.attrPlot[EditBase.ext_keyPos] = entitiesLabel; //实体
    }
    translateAll(position){
        super.translateAll(position);
        this.updateAllLabel();
    }
    rotationAll(position){
        super.rotationAll(position);
        this.updateAllLabel();
    }
    updateCenter(){
        super.updateCenter();
        this.updateAllLabel();
    }
    updateAllLabel() {
        var entitiesLabel = this.plot.attrPlot[EditBase.ext_keyPos]; //实体
        let sum=0;
        for (let i = 0; i < entitiesLabel.length - 1; i++) {
            var start = entitiesLabel[i].position.getValue();
            var end = entitiesLabel[i+1].position.getValue();
            var dis = getSpace(start, end);
            var disTxt = getDistanceText(dis);
            sum += dis;
            var sumTxt = getDistanceText(sum);
            var p = entitiesLabel[i+1];
            p.label.text = `+${disTxt}\n总长:${sumTxt}`;
        }
    }
    hideEdit(){
        
    }
}

export default EditDistanceSpace;